<template>
  <div
    class="modal fade"
    id="editScenarioDialog"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <!-- Close button in the upper right corner -->
          <button
            id="project-management-scenario-close-dialog-cross"
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            ×
          </button>

          <!-- Modal Title -->
          <h4 class="modal-title">
            <b>{{ lang.SC0000 }}</b>
          </h4>
          <p>
            <b>{{ lang.SC0020 }}:</b>
            {{ selectedClient }} - {{ nameOfSelectedClient }}
          </p>
        </div>
        <div class="modal-body">
          <div class="panel panel-default">
            <div class="panel-body">
              <div class="col-md-6" style="padding-left: 0">
                <!-- Searchbar - triggered by enter key -->
                <div
                  class="form-group searchbar col-md-6"
                  style="padding-left: 15px"
                >
                  <input
                    type="search"
                    class="form-control"
                    :placeholder="lang.SC0011"
                    v-model="filterScenarioString"
                    @input="doFilteringScenarios()"
                  />
                </div>
                <div
                  class="form-group searchbar col-md-6"
                  style="padding-left: 15px; top: 9px"
                >
                  <select2
                    id="selectedClientSelect"
                    class="form-control"
                    v-model="selectedClient"
                    :key="selectedClient"
                    :afterChange="getScenariosOfSelectedClient"
                  >
                    <option
                      v-for="client in clientList"
                      :value="parseInt(client.ClientId)"
                      :key="'option_' + client.ClientId"
                    >
                      {{ client.ClientName }}
                    </option>
                  </select2>
                </div>
                <!-- Scenario table -->
                <div
                  class="table-container table-scenarios"
                  style="clear: both"
                >
                  <table class="table table-striped table-hover">
                    <thead>
                      <tr>
                        <th class="text-center" style="width: 10%">
                          {{ lang.SC0012 }}
                        </th>
                        <th class="text-center" style="width: 30%">
                          {{ lang.SC0013 }}
                        </th>
                        <th class="text-center" style="width: 60%">
                          {{ lang.SC0014 }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        role="button"
                        :key="scenario.ScenarioGuid"
                        @click="selectScenario(scenario.ScenarioGuid)"
                        :class="{
                          info: isScenarioSelected(scenario.ScenarioGuid),
                          'cursor-not-allowed':
                            selectedTab === 'assignClientTab' &&
                            selectedClient < 0,
                        }"
                        v-for="scenario in filteredScenarios"
                      >
                        <td style="width: 10%">{{ scenario.ScenarioId }}</td>
                        <td style="width: 30%">{{ scenario.ScenarioName }}</td>
                        <td style="width: 60%">
                          {{ scenario.ScenarioDescription }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="col-md-6" style="padding-right: 0">
                <ul
                  class="nav nav-tabs nav-scenario-edit"
                  style="margin-bottom: 15px"
                >
                  <li class="active">
                    <a
                      href="#editScenarioTab"
                      data-toggle="tab"
                      @click="selectedTab = 'editScenarioTab'"
                      >{{ lang.SC0007 }}</a
                    >
                  </li>
                  <!-- <li v-if="globals.isAccessAllowed('LoopOp_ClientsScenarios_Read')">
                    <a
                      href="#assignClientTab"
                      data-toggle="tab"
                      @click="selectedTab = 'assignClientTab'"
                    >{{lang.SC0008}}</a>
                  </li>-->
                </ul>

                <div class="tab-content">
                  <div class="tab-pane fade active in" id="editScenarioTab">
                    <div class="form-group">
                      <label
                        for="inputScenarioName"
                        class="col-md-3 control-label"
                        >{{ lang.SC0004 }}</label
                      >
                      <div class="col-md-9">
                        <input
                          type="text"
                          class="form-control"
                          id="inputScenarioName"
                          maxlength="50"
                          @input="selectedScenarioDirty = true"
                          v-model="selectedScenario.ScenarioName"
                        />
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputScenarioLongtext"
                        class="col-md-3 control-label"
                        >{{ lang.SC0021 }}</label
                      >
                      <div class="col-md-9">
                        <input
                          type="text"
                          class="form-control"
                          id="inputScenarioLongtext"
                          maxlength="200"
                          @input="selectedScenarioDirty = true"
                          v-model="selectedScenario.ScenarioLongtext"
                        />
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputScenarioDescription"
                        class="col-md-3 control-label"
                        >{{ lang.SC0005 }}</label
                      >
                      <div class="col-md-9">
                        <div class="form-group nopadding">
                          <textarea
                            rows="3"
                            type="text"
                            class="form-control"
                            @input="selectedScenarioDirty = true"
                            v-model="selectedScenario.ScenarioDescription"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    <button
                      type="button"
                      class="btn btn-raised btn-top-bar"
                      @click="createNewScenario()"
                      :disabled="!selectedScenario.ScenarioId"
                    >
                      <i class="material-icons md-36">add_box</i>
                      <br />
                      {{ lang.SC0010 }}
                    </button>
                    <button
                      type="button"
                      id="project-management-scenario-save"
                      class="btn btn-raised btn-top-bar"
                      :class="{ 'btn-warning': selectedScenarioDirty }"
                      @click="saveSelectedScenario()"
                      :disabled="
                        selectedScenario.ScenarioName.length < 1 ||
                        (!globals.isAccessAllowed('LoopOp_Scenarios_Create') &&
                          !selectedScenario.ScenarioId) ||
                        (!globals.isAccessAllowed('LoopOp_Scenarios_Update') &&
                          selectedScenario.ScenarioId)
                      "
                    >
                      <i class="material-icons md-36">save</i>
                      <br />
                      {{ lang.SC0002 }}
                    </button>
                    <button
                      type="button"
                      class="btn btn-raised btn-top-bar"
                      @click="openDeleteScenarioConfirmationDialog()"
                      :disabled="
                        !selectedScenario.ScenarioId ||
                        selectedScenario.ScenarioId < 0 ||
                        !globals.isAccessAllowed('LoopOp_Scenarios_Delete')
                      "
                    >
                      <i class="material-icons md-36">delete</i>
                      <br />
                      {{ lang.SC0003 }}
                    </button>
                  </div>

                  <div class="tab-pane fade" id="assignClientTab">
                    <!-- Searchbar - triggered by enter key -->
                    <div
                      class="form-group searchbar"
                      style="padding-right: 15px"
                    >
                      <input
                        type="search"
                        class="form-control"
                        style="max-width: 40%; display: inline; float: left"
                        :placeholder="'Filter'"
                        v-model="filterClientString"
                        @input="doFilteringClients()"
                      />
                      <button
                        type="button"
                        class="btn btn-raised btn-default"
                        style="float: right; margin-left: 10px"
                        :class="{ 'btn-warning': unsavedAssignments }"
                        :disabled="
                          selectedClient < 0 ||
                          !globals.isAccessAllowed(
                            'LoopOp_ClientsScenarios_Update'
                          )
                        "
                        @click="saveScenariosOfSelectedClient()"
                      >
                        {{ lang.SC0002 }}
                      </button>
                      <button
                        type="button"
                        class="btn btn-raised btn-default"
                        style="float: right"
                        :class="{ 'btn-warning': copyScenarios }"
                        :disabled="selectedClient < 0 && !copyScenarios"
                        @click="copyScenariosClicked()"
                      >
                        {{ lang.SC0001 }}
                      </button>
                    </div>
                    <!-- Client table -->
                    <div class="table-container">
                      <table class="table table-striped table-hover">
                        <thead>
                          <tr>
                            <th class="text-center" style="width: 20%">
                              {{ lang.SC0012 }}
                            </th>
                            <th class="text-center" style="width: 80%">
                              {{ lang.SC0009 }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            role="button"
                            :key="client.ClientId"
                            @click="selectClient(client.ClientId)"
                            :class="{ info: isClientSelected(client.ClientId) }"
                            v-for="client in filteredClients"
                          >
                            <td style="width: 20%">{{ client.ClientId }}</td>
                            <td style="width: 80%">{{ client.ClientName }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <!-- Add modal buttons here -->
          <button
            id="project-management-scenario-close-dialog-button"
            type="button"
            class="btn btn-raised btn-default"
            data-dismiss="modal"
          >
            {{ lang.SC0006 }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Select2 from "../Tools/Select2";
import { v4 as uuidv4 } from "uuid";

export default {
  name: "ScenarioEditDialog",
  components: {
    Select2,
  },
  props: [
    "showDialog",
    "selectedProjectData",
    "clientList",
    "selectedClientFromProject",
  ],
  mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#editScenarioDialog").on("hidden.bs.modal", (e) => {
      this.$emit("dialogClosed");
    });

    // Register global events
    this.globals.$off("ScenarioDeleteModalYesConfirmation");
    this.globals.$on("ScenarioDeleteModalYesConfirmation", () => {
      this.deleteSelectedScenario();
    });
  },
  watch: {
    selectedTab(newValue) {
      this.tabVisibilityChanged();
      if (newValue === "assignClientTab") this.getScenariosOfSelectedClient();
    },
    showDialog() {
      if (this.showDialog) this.openScenarioEditDialog();
      else this.closeScenarioEditDialog();
    },
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
  data() {
    return {
      scenarios: [],
      filteredScenarios: [],
      filteredClients: [],
      filterScenarioString: "",
      filterClientString: "",
      selectedClient: -1,
      selectedTab: "editScenarioTab",
      copyScenarios: false,
      unsavedAssignments: false,
      selectedScenarioDirty: false,
      selectedScenario: {
        ScenarioGuid: "",
        ScenarioName: "",
        ScenarioDescription: "",
        ScenarioLongtext: "",
      },
      selectedScenarios: [],
      scenariosOfSelectedClient: [],
      lang: {
        SC0000: "Scenario Administration",
        SC0001: "Copy",
        SC0002: "Save",
        SC0003: "Delete",
        SC0004: "Name",
        SC0005: "Description",
        SC0006: "Close",
        SC0007: "Edit scenario",
        SC0008: "Assign scenarios",
        SC0009: "Client name",
        SC0010: "New",
        SC0011: "Filter",
        SC0012: "ID",
        SC0013: "Name",
        SC0014: "Description",
        SC0015: "Delete Scenario",
        SC0016: "Do you really want to delete the following scenario?",
        SC0017: "Yes",
        SC0018: "No",
        SC0019: "Project",
        SC0020: "Client",
        SC0021: "Longtext",
      },
    };
  },
  computed: {
    nameOfSelectedClient() {
      if (this.selectedClient < 0) return "";
      let client = _.find(this.clientList, (c) => {
        return c.ClientId == this.selectedClient;
      });
      if (client) return client.ClientName;
      return "";
    },
  },
  methods: {
    saveSelectedScenario() {
      let data, queryString;
      let currentScenarioIndex = _.findIndex(this.scenarios, (s) => {
        return s.ScenarioGuid === this.selectedScenario.ScenarioGuid;
      });
      if (currentScenarioIndex > -1) {
        // Scenario does already exist
        queryString = `api/Scenarios/${this.selectedScenario.ScenarioGuid}`;
        data = JSON.stringify(this.selectedScenario);

        $.ajax({
          method: "PUT",
          url: queryString,
          data: data,
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: (data) => {
            if (data.Error) {
              console.error(data.Error);
              this.globals.showErrorSnackbar(data.Error);
              return;
            }
            this.scenarios[currentScenarioIndex] = _.cloneDeep(
              this.selectedScenario
            );
            this.doFilteringScenarios();
            this.$forceUpdate();
            this.globals.showSuccessSnackbar("Scenario update successful");
            this.selectedScenarioDirty = false;
          },
          error: () => {
            console.error("Error on PUT in saveSelectedScenario()");
            this.globals.showErrorSnackbar("Scenario update failed");
          },
        });
      } else {
        // Scenario does not yet exist
        delete this.selectedScenario.ScenarioId;

        queryString = `api/Scenarios`;
        data = JSON.stringify(this.selectedScenario);

        $.ajax({
          method: "POST",
          url: queryString,
          data: data,
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: (data) => {
            if (data.Error) {
              console.error(data.Error);
              this.globals.showErrorSnackbar(data.Error);
              return;
            }
            if (data[0]) {
              if (data[0].ScenarioId)
                this.selectedScenario.ScenarioId = data[0].ScenarioId;
              if (data[0].ScenarioGuid)
                this.selectedScenario.ScenarioGuid = data[0].ScenarioGuid;
            }
            let scenario = _.cloneDeep(this.selectedScenario);
            this.scenarios.push(scenario);
            this.scenariosOfSelectedClient.push(scenario.ScenarioGuid);
            this.selectScenario(scenario.ScenarioGuid);
            this.doFilteringScenarios();
            this.$forceUpdate();
            this.globals.showSuccessSnackbar("Scenario update successful");
            this.selectedScenarioDirty = false;
          },
          error: () => {
            console.error("Error on POST in saveSelectedScenario()");
            this.globals.showErrorSnackbar("Scenario update failed");
          },
        });
      }
    },
    deleteSelectedScenario() {
      $.ajax({
        method: "DELETE",
        url: "api/Scenarios/" + this.selectedScenario.ScenarioGuid,
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          // If delete was successful, refresh displayed data and hide dialog
          this.globals.showSuccessSnackbar("Scenario deletion successful");
          _.remove(this.scenarios, (s) => {
            return s.ScenarioGuid === this.selectedScenario.ScenarioGuid;
          });
          this.createNewScenario();
          this.doFilteringScenarios();
        },
        error: () => {
          console.error("Scenario deletion failed in deleteSelectedScenario()");
          this.globals.showErrorSnackbar("Scenario deletion failed");
        },
      });
    },
    createNewScenario() {
      this.selectedScenario = {
        ScenarioGuid: uuidv4(),
        ScenarioName: "",
        ClientIds: [this.selectedClient],
      };
      this.selectedScenarios = [];
      this.selectedScenarioDirty = false;
    },
    copyScenariosClicked() {
      this.copyScenarios = !this.copyScenarios;
      this.selectedClient = -1;
      if (!this.copyScenarios) this.selectedScenarios = [];
    },
    getAllScenarios() {
      let queryString = "api/Scenarios";
      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.scenarios = [];
          if (data && data[0]) this.scenarios = data;
          this.doFilteringScenarios();
        },
        error: () => {
          console.error("Error on GET in getAllScenarios()");
          this.globals.showErrorSnackbar("Scenario request failed");
        },
      });
    },
    getScenariosOfSelectedClient() {
      let queryString = `api/Clients/${this.selectedClient}/Scenarios`;
      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          if (data) {
            if (this.selectedTab === "assignClientTab") {
              if (this.copyScenarios) {
                this.selectedScenarios = _.union(
                  this.selectedScenarios,
                  data.Scenarios
                );
                this.unsavedAssignments = true;
              } else {
                this.selectedScenarios = data.Scenarios || [];
                this.unsavedAssignments = false;
              }
            }
            if (data.Scenarios) this.scenariosOfSelectedClient = data.Scenarios;
            else this.scenariosOfSelectedClient = [];
          } else {
            this.selectedScenarios = [];
            this.scenariosOfSelectedClient = [];
          }
          this.copyScenarios = false;
          if (this.selectedTab === "editScenarioTab")
            this.doFilteringScenarios();
        },
        error: () => {
          console.error("Error on GET in getScenariosOfSelectedClient()");
          this.globals.showErrorSnackbar("Scenario request failed");
        },
      });
    },
    saveScenariosOfSelectedClient() {
      let queryString = `api/Clients/${this.selectedClient}/Scenarios`;
      let sendData = JSON.stringify({
        Scenarios: this.selectedScenarios,
      });

      $.ajax({
        method: "PUT",
        url: queryString,
        data: sendData,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          this.globals.showSuccessSnackbar(
            "Scenario assignment update successful"
          );
          this.unsavedAssignments = false;
        },
        error: () => {
          console.error("Error on PUT in saveScenariosOfSelectedClient()");
          this.globals.showErrorSnackbar("Scenario assignment update failed");
        },
      });
    },
    doFilteringScenarios() {
      // Reset filtering when search string is empty
      if (!this.scenarios || !this.scenarios[0]) return;

      let words = this.filterScenarioString.split(" ");
      let keys = ["ScenarioId", "ScenarioName", "ScenarioDescription"];

      const scenarioFilter = (scenario) => {
        if (
          this.selectedTab === "editScenarioTab" &&
          _.indexOf(this.scenariosOfSelectedClient, scenario.ScenarioGuid) < 0
        )
          return false;

        let containsSearch = false;
        words.forEach((word) => {
          keys.forEach((key) => {
            if (
              scenario[key] &&
              scenario[key]
                .toString()
                .toLowerCase()
                .indexOf(word.toLowerCase()) > -1
            ) {
              containsSearch = true;
              return;
            }
          });
        });
        return containsSearch;
      };
      this.filteredScenarios = this.scenarios.filter(scenarioFilter);
    },
    doFilteringClients() {
      // Reset filtering when search string is empty
      if (!this.clientList || this.clientList.length < 1) return;
      if (!this.filterClientString) {
        this.filteredClients = this.clientList;
        return;
      }

      let words = this.filterClientString.split(" ");
      let keys = ["ClientId", "ClientName"];

      const clientFilter = (client) => {
        let containsSearch = false;
        words.forEach((word) => {
          keys.forEach((key) => {
            if (
              client[key] &&
              client[key].toString().toLowerCase().indexOf(word.toLowerCase()) >
                -1
            ) {
              containsSearch = true;
              return;
            }
          });
        });
        return containsSearch;
      };
      this.filteredClients = this.clientList.filter(clientFilter);
    },
    getScenarioData(guid) {
      let sc = _.find(this.scenarios, (s) => {
        return s.ScenarioGuid === guid;
      });
      if (sc) sc = _.cloneDeep(sc);
      else sc = this.selectedScenario;
      return sc;
    },
    selectScenario(scenarioGuid) {
      if (this.selectedTab === "editScenarioTab") {
        this.selectedScenarios = [scenarioGuid];
        this.selectedScenarioDirty = false;
      } else {
        if (this.selectedClient < 0) return;
        let idx = _.indexOf(this.selectedScenarios, scenarioGuid);
        if (idx > -1) {
          _.pullAt(this.selectedScenarios, idx);
        } else {
          this.selectedScenarios.push(scenarioGuid);
        }
        this.unsavedAssignments = true;
      }

      if (this.selectedScenarios.length === 1)
        this.selectedScenario = this.getScenarioData(this.selectedScenarios[0]);
      else if (this.selectedScenarios.length < 1) this.createNewScenario();
      this.$forceUpdate();
    },
    isScenarioSelected(scenarioGuid) {
      return _.indexOf(this.selectedScenarios, scenarioGuid) > -1;
    },
    selectClient(id) {
      this.getScenariosOfSelectedClient(id);
    },
    isClientSelected(id) {
      return this.selectedClient == id;
    },
    openDeleteScenarioConfirmationDialog() {
      this.globals.$emit(
        "openGlobalConfirmationDialog",
        this.getDeleteDialogData()
      );
    },
    getDeleteDialogData() {
      return {
        initiator: "ScenarioDeleteModal",
        confirmationTitle: this.lang.SC0015,
        colorRed: true,
        yesButtonText: this.lang.SC0017,
        noButtonText: this.lang.SC0018,
        htmlText: `<p><b>${this.lang.SC0016}</b></p>
        <div class="form-group">
          <label class="col-md-3 text-black">${this.lang.SC0012}</label>
          <label class="col-md-9 text-black">${this.selectedScenario.ScenarioId}</label>
        </div>
        <div class="form-group">
          <label class="col-md-3 text-black">${this.lang.SC0013}</label>
          <label class="col-md-9 text-black">${this.selectedScenario.ScenarioName}</label>
        </div>`,
      };
    },
    tabVisibilityChanged() {
      this.selectedScenarios = [];
      this.createNewScenario();
      this.copyScenarios = false;
      this.unsavedAssignments = false;
      this.selectedScenarioDirty = false;
      this.doFilteringScenarios();
    },
    openScenarioEditDialog() {
      this.selectedClient = this.selectedClientFromProject;
      this.getScenariosOfSelectedClient();
      this.tabVisibilityChanged();
      this.getAllScenarios();
      this.doFilteringClients();
      $("#editScenarioDialog").modal("show");
    },
    closeScenarioEditDialog() {
      $("#editScenarioDialog").modal("hide");
    },
  },
};
</script>

<style scoped>
.modal-lg {
  width: calc(100vw - 300px);
}

.table-container {
  height: calc(100vh - 355px);
  overflow-y: auto;
}
.table-scenarios {
  height: calc(100vh - 300px);
}

.modal-content {
  background-color: #eee;
}

#editScenarioDialog .panel-body {
  padding: 0 !important;
}

.modal-footer .btn-default {
  background: rgb(190, 190, 190);
}

.btn-top-bar.btn.btn-raised.btn-warning {
  background-color: #ff5722;
}
.btn.btn-raised.btn-warning:hover {
  background-color: #ec5122ab;
}

/* Tabs for scenario edit mode */
.nav-scenario-edit {
  background-color: var(--color-primary);
  padding: 0px;
}
.nav-scenario-edit > li {
  text-align: center;
  float: none;
  display: inline-block;
}
.nav-scenario-edit > li.active {
  background-color: rgba(255, 255, 255, 0.1);
}
.nav-scenario-edit > li.active > a {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// ScenarioEditModal.vue?65a258a6